import React from "react";
import { Toaster } from "../ui/sonner";
import { UserAccountSidebar, UserAddress, UserPaymentMethod, UserProfile } from "@/components";
import UserPreferences from "../userPreferences/UserPreferences";
import { OrderHistory, QuickReorder } from "@/screens";

const UserAccountDashboard = () => {
  const [activeTab, setActiveTab] = React.useState("profile");

  const renderContent = () => {
    switch (activeTab) {
      case "profile":
        return <UserProfile />;
      case "addresses":
        return <UserAddress />;
      case "payment-methods":
        return <UserPaymentMethod />;
      case "preferences":
        return <UserPreferences />;
      case "quick-reorder":
        return <QuickReorder className="py-2" />;
      case "order-history":
        return <OrderHistory className="py-2" />;
      default:
        return <UserProfile />;
    }
  };
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="container  mx-auto ">
        <h1 className="text-3xl font-bold mb-8 text-gray-900">My Account</h1>

        <div className="flex gap-6 w-full ">
          <div className="w-64 flex-shrink-0">
            <UserAccountSidebar activeTab={activeTab} onTabChange={setActiveTab} />
          </div>

          <div className="flex-1 ">{renderContent()}</div>
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default UserAccountDashboard;
